import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Mail, Loader2, MailCheck } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";
import { toast } from "sonner";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) { toast.error("Inserisci la tua email"); return; }
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
    } catch (e) {
      // Backend always returns 200 to avoid leaking user existence, but
      // catch just in case (network etc.).
      toast.error("Errore — riprova tra qualche secondo");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAF7] flex flex-col justify-center px-6 py-10">
      <div className="max-w-md w-full mx-auto">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-800" data-testid="forgot-back">
          <ArrowLeft className="w-4 h-4" /> Torna al login
        </Link>
        <div className="mt-8 ios-card p-8">
          {!sent ? (
            <>
              <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-[#12466F] to-[#0A84FF] flex items-center justify-center shadow-lg">
                <Mail className="w-6 h-6 text-white" />
              </div>
              <div className="mt-4 text-[10px] uppercase tracking-[0.3em] text-slate-500 font-semibold">Recupero password</div>
              <h1 className="font-display font-black text-2xl mt-1">Password dimenticata?</h1>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">
                Inserisci l'email del tuo account: ti invieremo un link per reimpostare la password (valido 60 minuti).
              </p>
              <form onSubmit={submit} className="mt-6 space-y-4">
                <div>
                  <Label className="text-[11px] uppercase tracking-widest text-slate-500">Email</Label>
                  <Input
                    data-testid="forgot-email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="tu@esempio.com"
                    required
                    className="rounded-xl mt-1 bg-slate-50 border-slate-200 h-11"
                  />
                </div>
                <Button
                  type="submit"
                  data-testid="forgot-submit"
                  disabled={busy}
                  className="w-full h-11 rounded-full bg-slate-900 hover:bg-slate-800 text-white font-semibold"
                >
                  {busy ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Invio…</> : "Invia link di reset"}
                </Button>
              </form>
            </>
          ) : (
            <div className="text-center py-4">
              <div className="w-14 h-14 mx-auto rounded-2xl bg-emerald-100 flex items-center justify-center">
                <MailCheck className="w-7 h-7 text-emerald-600" />
              </div>
              <h1 className="font-display font-black text-2xl mt-4">Email inviata</h1>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">
                Se un account con <b>{email}</b> esiste, riceverai a breve il link per reimpostare la password.
                Controlla anche la cartella spam.
              </p>
              <Link to="/" className="inline-block mt-6 text-sm text-[#0A84FF] hover:underline" data-testid="forgot-return">Torna al login</Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
